/**
 * @summary
 * <blockquote>Determines the appropriate error type category based on error code</blockquote>
 **/
import { NETWORK_ERROR_TYPES } from '@shared/constants';
import type { NetworkErrorType } from '@shared/constants';

export function getErrorTypeForCode(errorCode: string): NetworkErrorType {
  const code = errorCode.toUpperCase();
  
  if (code.includes('CONNECT') || code.includes('REFUSED') || code.includes('RESET')) {
    return NETWORK_ERROR_TYPES.CONNECTION;
  } else if (code.includes('TIMEOUT')) {
    return NETWORK_ERROR_TYPES.TIMEOUT;
  } else if (code.includes('NOTFOUND') || code.includes('DNS')) {
    return NETWORK_ERROR_TYPES.DNS;
  } else if (code.includes('SSL') || code.includes('TLS')) {
    return NETWORK_ERROR_TYPES.SSL;
  } else if (code.includes('DB') || code.includes('DATABASE')) {
    return NETWORK_ERROR_TYPES.DATABASE;
  } else if (code.includes('AUTH')) {
    return NETWORK_ERROR_TYPES.AUTHENTICATION;
  } else if (code.includes('RATE') || code.includes('LIMIT')) {
    return NETWORK_ERROR_TYPES.RATE_LIMIT;
  }
  
  return NETWORK_ERROR_TYPES.SERVER;
} 